import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { BaseApiService } from './base-api.service';
import { VerifyApiModel } from '../models';

/**
 * Verification API Service
 */
@Injectable({
    providedIn: 'root'
})
export class VerificationService extends BaseApiService {

    /**
     * Verify data integrity
     */
    verifyDataIntegrity(): Observable<VerifyApiModel> {
        return this.get<VerifyApiModel>('/verification/data-integrity')
            .pipe(map(response => response.data!));
    }

    /**
     * Verify system configuration
     */
    verifySystemConfiguration(): Observable<VerifyApiModel> {
        return this.get<VerifyApiModel>('/verification/system-configuration')
            .pipe(map(response => response.data!));
    }

    /**
     * Verify database consistency
     */
    verifyDatabaseConsistency(): Observable<VerifyApiModel> {
        return this.get<VerifyApiModel>('/verification/database-consistency')
            .pipe(map(response => response.data!));
    }

    /**
     * Verify file system
     */
    verifyFileSystem(): Observable<VerifyApiModel> {
        return this.get<VerifyApiModel>('/verification/file-system')
            .pipe(map(response => response.data!));
    }
}
